import React, { useState, useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import isEmail from 'validator/lib/isEmail'
import api from 'services/pet-notify-api'

import { createFreeSignup } from '../../../../store/signup/actions'
import SignupUserInfoScreen from '../../../../screens/Signup/Free/UserInfo'
import { validatePhoneNumber } from 'services/validate-phone-number'

type Props = {
  user?: SignupUserInfo
}

function SignupUserInfoScreenContainer(props: Props & RouteComponentProps) {
  const dispatch = useDispatch()
  const { user, history, promoCode } = props
  const [isLoading, setIsLoading] = useState(false)
  const [isCaptchaSuccessful, setIsCaptchaSuccessful] = useState(false)
  const [phoneNumberError, setPhoneNumberError]:any = useState(null)

  function handleCaptcha() {
    setIsCaptchaSuccessful(true)
  }

  async function handleSubmit(data: SignupUserInfo) {
    setIsLoading(true)

    try {
      // if (!data.agree) {
      //   throw new Error(
      //     'Please verify you understand that Pet Notify is only available in the US and Canada',
      //   )
      // }
      if (!data.policyAcceptance) {
        throw new Error(
          'Please verify you understand the User Agreement and Privacy Policy',
        )
      }
      if (!data.smsPermission) {
        throw new Error(
          'Please verify you agree to receive SMS alerts.',
        )
      }
      if (!isCaptchaSuccessful) {
        throw new Error('Captcha is required')
      }
      if (!data.firstName) {
        throw new Error('First name required')
      }
      if (!data.lastName || data.lastName === '') {
        throw new Error('Last name required')
      }
      if (!data.email || data.email === '') {
        throw new Error('Email is required')
      }
      if (!isEmail(data.email)) {
        throw new Error('Email must be a valid email address')
      }
      if (data.email !== data.confirmEmail) {
        throw new Error('Your emails do not match')
      }
      if (!data.phone) {
        throw new Error('Phone number is required')
      }
      if (data.phone) {
        try {
          const response: any = await api.signup.isPhoneAvailable({ phone: data.phone })
          if (!response.isPhoneAvailable) {
            setPhoneNumberError('An account with this phone number already exists. Please log in using the Pet Notify mobile app or visit https://app.petnotify.com/signin. You can also reset your password using your registered email if needed.')
            setIsLoading(false)
            return
          } else {
            setPhoneNumberError(null)
          }
        } catch (error) {
          throw new Error('Phone number already in use')
        }
      }
      if (!data.country || data.country === '') {
        throw new Error('Country is required')
      }

      if (!data.state || data.state === '') {
        throw new Error('State is required')
      }
      if (!data.city || data.city === '') {
        throw new Error('City is required')
      }
      if (!data.zip || data.zip === '') {
        throw new Error('Zip is required')
      }

      const validation = validatePhoneNumber(data.phone)

      if (!validation.valid) {
        throw new Error(validation.message)
      }

      setIsLoading(false)
      await dispatch(createFreeSignup({ ...user, ...data, promoCode }))
      history.push('/signup/success')
    } catch (e) {
      setIsLoading(false)
      throw e
    }
  }

  return (
    <SignupUserInfoScreen
      onSubmit={handleSubmit}
      onCaptcha={handleCaptcha}
      isLoading={isLoading}
      initialValues={user}
      phoneNumberError={phoneNumberError}
    />
  )
}

type ReduxState = {
  signup: {
    user?: UserInfo
  }
}

export default connect((state: State) => ({
  user: state.signup.user,
  promoCode: state.promoCode && state.promoCode.code,
}))(SignupUserInfoScreenContainer)
